import ArrowDropDown from '@mui/icons-material/ArrowDropDown';
import ArrowDropUp from '@mui/icons-material/ArrowDropUp';
import { Box, Typography } from '@mui/material';

import type { FundMovementType } from './types';

export interface MovementTypeChipProps {
  type: FundMovementType;
}

const TYPE_LABEL: Record<FundMovementType, string> = {
  compra: 'Compra',
  venda: 'Venda',
};

export function MovementTypeChip({ type }: MovementTypeChipProps) {
  const isPurchase = type === 'compra';

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25 }}>
      {isPurchase ? (
        <ArrowDropUp color="success" sx={{ fontSize: 28 }} aria-hidden />
      ) : (
        <ArrowDropDown color="error" sx={{ fontSize: 28 }} aria-hidden />
      )}
      <Typography variant="body2" color="text.primary">
        {TYPE_LABEL[type]}
      </Typography>
    </Box>
  );
}
